import React from 'react';
import { FileIconBase } from './_base';
const ImageFileIcon = (props) => (React.createElement(FileIconBase, Object.assign({}, props, { defaultColor: "#7A4FB7", label: "IMG" })));
export default ImageFileIcon;
